import { useFormikContext } from "formik";
import {
  InputField,
  ControlcenterMelcoControlCenterModelsForwardLinkListItem,
  VerticalForm,
} from "melco-shared-logic";
import { Button, Space, SaveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type DisplayEditForwardFormProps = {
  ForwardLinkDetails: ControlcenterMelcoControlCenterModelsForwardLinkListItem;
};

export const DisplayEditForwardForm: React.FC<DisplayEditForwardFormProps> = ({
  ForwardLinkDetails,
}) => {
  const { t } = useTranslation();
  const { isSubmitting, submitForm } = useFormikContext();

  return (
    <>
      <div>
        <Right direction="vertical" size="small">
          <Button
            icon={<SaveIcon />}
            type="primary"
            // disabled={isSubmitting}
            loading={isSubmitting}
            onClick={() => {
              submitForm();
            }}
            style={{ marginBottom: "15px" }}
          >
            {t("url_forward.actions.edit.button")}
          </Button>
        </Right>

        <VerticalForm>
          <InputField
            name="id"
            value={ForwardLinkDetails.id ? ForwardLinkDetails.id : ""}
            hidden
          />
          <InputField
            name="key"
            label={t("url_forward.actions.edit.form.input.key")}
            value={ForwardLinkDetails.key ? ForwardLinkDetails.key : ""}
          />
          <InputField
            name="target"
            label={t("url_forward.actions.edit.form.input.target")}
            value={
              ForwardLinkDetails.target_url ? ForwardLinkDetails.target_url : ""
            }
          />
        </VerticalForm>
      </div>
    </>
  );
};
